export const GAUGE_DIMENSIONS = {
  VIEWBOX_WIDTH: 200,
  VIEWBOX_HEIGHT: 100,
  ARC_RADIUS: 70,
  INNER_RADIUS: 66,
  START_X: 30,
  END_X: 170,
  CENTER_X: 100,
  CENTER_Y: 90,
  ARC_LENGTH: 220,
} as const;

export const GAUGE_VISUAL = {
  STROKE_WIDTH: 4,
  DOT_RADIUS: 2,
  DOT_COUNT: 20,
  DOT_ANGLE_STEP: 20,
  DOT_ANGLE_OFFSET: -80,
  ASPECT_RATIO: '2 / 1',
} as const;

export const GAUGE_COLORS = {
  SUCCESS_THRESHOLD: 50,
} as const;

export const GAUGE_ANIMATION = {
  TRANSITION_DURATION: '0.3s',
  TRANSITION_EASING: 'ease-in-out',
} as const;
